import coreHelper from "@/utils/coreHelper";
import apiService from "./apiService";

const rptaxService = {
    async lookup(td){
        const resp  = await apiService.get(`rptax/${td?.trim()}/lookup`,{},true);
        return resp.data;
    },
    async getLinkedAccounts(){
        try{
            const resp = await apiService.get(`rptax/get-linked-accounts`,{},true);
            return resp.data;
        }
        catch{
            return [];
        }
    },
    async bindAccount(td){
        try{
            const resp = await apiService.put(`rptax/${td?.trim()}/bind-account`,{},true);
            return resp.data;
        }
        catch{
            return {};
        }
    },
    async removeAccount(td){
        try{
            const resp = await apiService.delete(`rptax/${td?.trim()}/remove-account`,true);
            return resp.data;
        }
        catch{
            return coreHelper.createGenericResponseError();
        }
    },
    async getBllingStatement(key){
        try{
            const resp = await apiService.get(`rptax/${key}/get-billing-statement`,{},true);
            return resp.data;
        }
        catch{
            return {};
        }
    }
}

export default rptaxService;